import * as React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import Animated, { Easing, withRepeat, withTiming, useSharedValue, useAnimatedStyle, } from 'react-native-reanimated';
import { rem } from 'design-system';
import LOGO_2_PNG from 'design-system/img/blackrock-logo.png';
import LOGO_1_PNG from 'design-system/img/ishares-logo.png';
import LOGO_3_PNG from 'design-system/img/vaneck-logo.png';
import LOGO_0_PNG from 'design-system/img/vanguard-logo.png';
const LOGO_PNGS = [LOGO_0_PNG, LOGO_1_PNG, LOGO_2_PNG, LOGO_3_PNG];
const LOGO_COUNT = LOGO_PNGS.length;
const ROTATE_DEGREES = [-10, 10]; // length divides LOGO_COUNT
const CYCLE_MS = 1800;
const DISMISS_MS = 400;
const HOLD_FRACTION = 1 - DISMISS_MS / CYCLE_MS;
const LOGO_ANIMATE_TRANSLATE = rem(80);
const LogoItem = React.memo(({ logo, index, progress }) => {
    const animatedStyle = useAnimatedStyle(() => {
        const floor = Math.floor(progress.value);
        const currentTop = floor % LOGO_COUNT;
        const frac = progress.value - floor;
        let opacity = 1;
        let translateX = 0;
        if (currentTop === index && frac > HOLD_FRACTION) {
            const t = (frac - HOLD_FRACTION) / (1 - HOLD_FRACTION);
            opacity = 1 - Easing.cubic(t);
            translateX = Easing.cubic(t) * LOGO_ANIMATE_TRANSLATE;
        }
        else if (currentTop === (index + 1) % LOGO_COUNT) {
            opacity = 0;
        }
        const rotateDeg = ROTATE_DEGREES[index % ROTATE_DEGREES.length];
        const direction = [-1, 1][Math.floor(index / ROTATE_DEGREES.length) % 2];
        return {
            zIndex: (LOGO_COUNT - 1 - index + currentTop) % LOGO_COUNT,
            opacity,
            transform: [{ rotate: `${rotateDeg}deg` }, { translateX: direction * translateX }],
        };
    });
    return (<Animated.View style={[styles.logoContainer, animatedStyle]}>
        <Image source={logo} style={styles.image}/>
      </Animated.View>);
});
const Logos = React.memo(() => {
    const progress = useSharedValue(0);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            progress.value = withRepeat(withTiming(LOGO_COUNT, {
                duration: LOGO_COUNT * CYCLE_MS,
                easing: Easing.linear,
            }), -1, false);
        }, 500);
        return () => {
            clearTimeout(timeout);
        };
    }, [progress]);
    return (<View style={styles.logosContainer}>
      {LOGO_PNGS.map((logo, index) => (<LogoItem key={index} logo={logo} index={index} progress={progress}/>))}
    </View>);
});
export default React.memo(Logos);
const styles = StyleSheet.create({
    image: {
        width: '100%',
        height: '100%',
        borderRadius: rem(8),
    },
    logosContainer: {
        width: '88%',
        height: '88%',
    },
    logoContainer: {
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
});
